<div class="ai-disclaimer-modal modal-content">
  <div class="modal-header">
    <h1 class="modal-title">{{ '::AiDisclaimerModalTitle' | abpLocalization }}</h1>
  </div>

  <div class="modal-body">
    <div *ngIf="isLoading" class="text-center py-3">
      <span>{{ '::Loading' | abpLocalization }}</span>
    </div>
    <div *ngIf="!isLoading" class="disclaimer-content" [innerHTML]="disclaimerText | markdown"></div>
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary" (click)="close()">
      {{ '::Close' | abpLocalization }}
    </button>
  </div>
</div>
